import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { HttpService } from '../../../services/http.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LazyLoadImageModule } from 'ng-lazyload-image';
declare var $: any;

@Component({
  standalone: true,
  imports: [FontAwesomeModule, LazyLoadImageModule, CommonModule],
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
})
export class ReviewsComponent implements OnInit, OnDestroy {
  @ViewChild('parent') slider: ElementRef;
  @Input() creatorId: any = null;
  @Input() page: string;
  loading: boolean = false;
  faStar = faStar;
  mouseDown: boolean = false;
  startX: any;
  scrollLeft: any;
  i = 0;
  autoSlideInterval: any;
  reviews = [
    {
      name: 'Sarah Johnson',
      review:
        'Chatting with Mackenzie on Mentoga was an unforgettable experience. The personal insights and genuine conversation we had were incredible. Mentoga has truly redefined fan engagement for me.',
      rating: '4',
    },
    {
      name: 'Ava Martinez',
      review:
        "Booking a one-on-one meeting with Jacob Sapochnick on Mentoga was enlightening. The platform's seamless interaction and the depth of our conversation were beyond my expectations. Mentoga is a game-changer.",
      rating: '5',
    },
    {
      name: 'David Kim',
      review:
        "Mentoga has transformed how I interact with inspiring figures. The platform is intuitive, and the experience is beyond what I expected. It's not just a fan service; it's a community of meaningful engagement.",
      rating: '5',
    },
    {
      name: 'Emily Patel',
      review:
        "I'm blown away by the depth of interaction Mentoga offers. It's not just about fan messages; it's about real connections. The chat feature is seamless and makes every conversation special.",
      rating: '4',
    },
    {
      name: 'Alex Thompson',
      review:
        "Having the opportunity to express my appreciation to Daniel Martiz through Mentoga's Coffee feature was amazing. The platform's unique approach to fan-creator connections is unmatched. It's not just about following your favorites; it's about truly connecting with them.",
      rating: '5',
    },
    {
      name: 'Michael Lee',
      review:
        "The personalized session I booked on Mentoga was both professional and heartwarming. It's rare to find a platform that offers such genuine interactions. Mentoga really understands what it means to connect.",
      rating: '4',
    },
    {
      name: 'Jessica Smith',
      review:
        'The one-on-one session I had with Olivia Rose on Mentoga was transformative. The platform not only made it easy to connect but also ensured a meaningful and professional experience. Mentoga is at the forefront of the creator economy.',
      rating: '4',
    },
  ];
  creatorReviews: any = this.reviews;

  constructor(
    private http: HttpService,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    if (this.page !== 'home') {
      this.loadData();
    }
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    clearInterval(this.autoSlideInterval);
  }

  async loadData() {
    try {
      if (!this.creatorId) {
        return;
      }
      this.loading = true;
      const response: any = await this.http
        .get(
          `api/MentorRating/mentor-review-listing?mentorid=${this.creatorId}`,
          false,
          false,
        )
        .toPromise();

      if (response.status) {
        this.creatorReviews = response.modelList;
      } else {
        this.creatorReviews = [];
      }
    } catch (error) {
      console.error('An error occurred while loading data:', error);
      this.creatorReviews = [];
    } finally {
      this.loading = false;
    }
  }

  startDragging(e: any, flag: any, slider: any) {
    this.mouseDown = true;
    this.startX = e.pageX - slider.nativeElement.offsetLeft;
    this.scrollLeft = slider.nativeElement.scrollLeft;
  }

  stopDragging(e: any, flag: any) {
    this.mouseDown = false;
  }

  moveEvent(e: any, slider: any) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - slider.nativeElement.offsetLeft;
    const scroll = x - this.startX;
    slider.nativeElement.scrollLeft = this.scrollLeft - scroll;
  }

  startAutoSlide() {
    this.autoSlideInterval = setInterval(() => {
      this.i = (this.i + 1) % this.creatorReviews.length;
      this.scrollToReview(this.i);
    }, 3000);
  }

  scrollToReview(index: number) {
    const reviewSecElements =
      this.slider.nativeElement.querySelectorAll('.reviewSec');
    if (reviewSecElements && reviewSecElements.length > index) {
      const targetReviewSec = reviewSecElements[index] as HTMLElement;
      this.renderer.setProperty(
        this.slider.nativeElement,
        'scrollLeft',
        targetReviewSec.offsetLeft,
      );
    }
  }
}
